import CookiesJS from 'cookies-js';
import {submitHandler} from './submit-handler';
import {refreshExcludedCounter} from './excludeCounter';
import {startBuildAfterSave} from './userForm/rebuildProgramms';

export function initDisallowProducts($, apiClient) {
    if (!$('.exclude-product__input').length) return;

    refreshExcludedCounter($);
    $(document).on('change', '.exclude-product__input', function () {
        refreshExcludedCounter($);
    });

    // На странице эксперта тот же список, но сохраняем не себя,
    // а клиента: его идентификатор лежит на форме.
    const clientId = ($('.exclude-form').attr('data-client-id') || '').trim();

    submitHandler('.action__disallow-products', async function () {
        const disallowedProducts = [];
        $('.exclude-product__input').each(function() {
            if ($(this).is(':checked')) {
                disallowedProducts.push($(this).val());
            }
        });
        const updates = {
            disallowedProducts,
            productsExcluded: true
        };
        if (clientId) {
            await apiClient.updateUserById(clientId, updates, CookiesJS.get('auth_token'));
        } else {
            await apiClient.updateUser(updates, CookiesJS.get('auth_token'));
        }
        // Со страницы больше не уходим: сборка запускается здесь же,
        // и виджет над кнопкой показывает, что происходит. Прежде
        // человека уносило на другую страницу, и результат исключения
        // он не видел вовсе.
        await startBuildAfterSave(apiClient);
    });
}
